import React, { useState } from 'react';
import { NumberInput, TextInput, required, BooleanInput } from 'react-admin';
import { nonNegativeInt } from 'utils/validation';
import { BaseForm } from '../../Components';

const nonNegativeIntValidation = [required(), nonNegativeInt];

const SuspectForm = (props) => {
  const { record } = props;

  const [isMurderer, setIsMurderer] = useState(
    record.murderBoxChecked || false
  );

  const handleCheckBox = (event) => {
    event.preventDefault();
    setIsMurderer(!isMurderer);
  };

  return (
    <BaseForm {...props}>
      <TextInput source="name" validate={required()} />
      <NumberInput
        source="priorityNumber"
        validate={nonNegativeIntValidation}
      />
      <NumberInput
        source="requiredActors"
        validate={nonNegativeIntValidation}
      />
      <BooleanInput
        label="Murderer"
        source="murderBoxChecked"
        onInput={handleCheckBox}
      />
      {isMurderer ? (
        <TextInput source="motive" multiline validate={required()} />
      ) : null}
    </BaseForm>
  );
};

export default SuspectForm;
